(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('printPreview', {
        templateUrl: 'views/components/views/printPreview/printPreview.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: [
            '$sce',
            '$stateParams',
            'stateService',
            'printService',
            'ieScreenBlockService',
            'p2ReportDefService',
            'pdfService',
            'rememberService',
            function ($sce, $stateParams, stateService, printService, ieScreenBlockService, p2ReportDefService, pdfService, rememberService) {
                // #region VARIABLES & DEFINITIONS

                const vm = this;
                let webPage = stateService.getCurrentName();
                let webpageParam = $stateParams.webpage;
                let argType = $stateParams.argtype;
                let argValue = $stateParams.argvalue;
                let reportKeyno = $stateParams.report_keyno;
                let printerKeyno = $stateParams.printer_keyno;
                let reportDefinitions = {};

                vm.model = {
                    webPage: webPage,
                    webpageParam: webpageParam,
                    argType: argType,
                    argValue: argValue,
                    previewLink: '',
                };

                // #endregion VARIABLES & DEFINITIONS

                // #region LOAD PROCEDURE FUNCTION CALL

                const load = async function () {
                    ieScreenBlockService.start();

                    p2ReportDefService.getEdit({ p2_reportdef_keyno: reportKeyno }).then(async function (data) {
                        reportDefinitions = data[0];

                        const parms = {
                            reportKeyno: reportDefinitions.printserver_keyno,
                            parameters: { [argType]: argValue },
                        };

                        let url = '';

                        switch (reportDefinitions.report_type_keyno) {
                            case '1':
                                url = await printService.preview(parms);
                                break;
                            case '2':
                                url = await pdfService.preview({
                                    reportKeyno: reportKeyno,
                                    parameters: { [argType]: argValue },
                                });
                                break;
                            default:
                                console.error('Invalid report type in printPreview.component for report keyno: ' + $stateParams.report_keyno);
                                break;
                        }
                        if (url) {
                            vm.model.previewLink = $sce.trustAsResourceUrl(url);
                        }
                        ieScreenBlockService.stop();
                    });
                };

                // #endregion LOAD PROCEDURE FUNCTION CALL

                // #region PRINT BUTTON FUNCTION

                vm.print = async function () {
                    if (printerKeyno < 1) {
                        console.error('No printer selected');
                        return;
                    }

                    const parms = {
                        printerKeyno: printerKeyno,
                        reportKeyno: reportDefinitions.printserver_keyno,
                        parameters: { [argType]: argValue },
                    };

                    ieScreenBlockService.start();

                    switch (reportDefinitions.report_type_keyno) {
                        case '1':
                            parms.printerProperties = {
                                isLandscape: reportDefinitions.isLandscape,
                                pageAutoSize: true,
                            };
                            await printService.print(parms);
                            break;
                        case '2':
                            parms.reportKeyno = reportKeyno;
                            await pdfService.printPDF(parms);
                            break;
                        default:
                            console.error('Invalid report type in printPreview.component for report keyno: ' + $stateParams.report_keyno);
                            break;
                    }
                    ieScreenBlockService.stop();
                };

                vm.gotoEmailCreate = async function () {
                    await rememberService.remember('goto.emailcreate.selectedreport', reportKeyno);
                    return stateService.go('emailcreate', { webpage: vm.model.webpageParam, argtype: vm.model.argType, argvalue: vm.model.argValue });
                };

                // #endregion PRINT BUTTON FUNCTION

                // #region ON INIT FUNCTION

                vm.$onInit = function () {
                    load();
                };

                // #endregion ON INIT FUNCTION
            },
        ],
    });
})();
